import { render } from "./IndexCreate.vue?vue&type=template&id=449ca7b3&ts=true"
import script from "./IndexCreate.vue?vue&type=script&lang=ts"
export * from "./IndexCreate.vue?vue&type=script&lang=ts"

import exportComponent from "/var/code/static/vue_drax/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__